import { CommonModule } from "@angular/common";
import { Component, forwardRef, Input, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { ItemArgs } from "@progress/kendo-angular-dropdowns";
import { FileRestrictions, RemoveEvent, SelectEvent } from "@progress/kendo-angular-upload";
import { KendoModule } from "@shared/kendo/kendo.module";
import { BehaviorSubject, Subject, takeUntil, tap } from "rxjs";
import { ServiceTypeId } from "src/app/core/models/requests";
import { NomenclatureService } from "src/app/core/services/nomenclature.service";
import { MedikoRequestType } from "src/app/features/mediko-requests/models/meidko-request-type.model";
import { environment } from "src/environments/environment";
import { NomenclatureType } from "../autocomplete/autocomplete-query.service";
import { DOCUMENT_TYPE_PLACEHOLDER } from "./file-select.constants";

@Component({
    selector: 'app-file-selector',
    templateUrl: './file-select.component.html',
    styleUrls: ['./file-select.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => FileMultiselectComponent),
          multi: true,
        },
    ],
    imports: [ReactiveFormsModule, KendoModule, CommonModule, FormsModule],
})
export class FileMultiselectComponent implements OnInit, OnDestroy, ControlValueAccessor {

    @Input() multiple = false;
    @Input() disabled = false;
    @Input() showFileList = true;
    @Input() dropFileHereMessage = 'Drop files here';
    @Input() selectMessage = 'Select file';
    @Input() requestType: MedikoRequestType | keyof typeof MedikoRequestType = MedikoRequestType.WorkerList;
    @Input() serviceType: ServiceTypeId | keyof typeof ServiceTypeId = ServiceTypeId.Supplier;

    readonly documentTypePlaceholder = DOCUMENT_TYPE_PLACEHOLDER;
    readonly filesRestrictions: FileRestrictions = {
        allowedExtensions: environment.fileUploadRestrictions.allowedExtensions,
        maxFileSize: environment.fileUploadRestrictions.maxFileSize
    };
    readonly nomenclatureType = NomenclatureType;

    documentTypes = []

    private _destroy$: Subject<any> = new Subject();
    private _value$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    constructor(private service: NomenclatureService) {}

    get requestTypeId() {
        return this.requestType;
    }

    ngOnInit(): void {
        let filter = {
            Request: this.requestType,
            ServiceType: this.serviceType,
        }
        this.service.getDocumentTypes(filter)
            .subscribe(res => this.documentTypes = res);

        this._value$
            .pipe(
                takeUntil(this._destroy$),
                tap(console.log)
            )
            .subscribe(res => {
                this._onChange(res && res.length > 0 ? res : null);
            });
    }

    ngOnDestroy(): void {
        this._destroy$.next(undefined);
    }

    onSelect(e: SelectEvent) {

    }

    onRemove(e: RemoveEvent) {

    }

    valueChange(e: any) {
        this._value$.next(e);
    }

    writeValue(obj: any): void {
        this._value$.next(obj)
    }

    registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouch = fn;
    }

    documentTypeValueNormalizer(data: any) {
        return `${data?.name}`
    }

    itemDisabled = (context: ItemArgs) => !context?.dataItem?.id;
    
    private _onChange = (data: any) => {};
    private _onTouch = () => {};
}